import { render, staticRenderFns } from "./LabKeywords.vue?vue&type=template&id=12f821dc&"
import script from "./LabKeywords.vue?vue&type=script&lang=js&"
export * from "./LabKeywords.vue?vue&type=script&lang=js&"
import style0 from "./LabKeywords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports